module.exports = __webpack_public_path__ + "static/media/attendance-on.3a6c0614.svg";